import { Module } from '@nestjs/common';
import { TranslationController } from './translation.controller';
import { TranslationService } from './translation.service';

@Module({
    controllers: [TranslationController],
    providers: [TranslationService],
})
export class TranslationModule { }